/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/prescriptions-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        rxNumber: 60,
        drugName: 120,
        quantity: 40,
        cagName:60,
        daysSupply: 40,
        directionOfUse: 80,
        claimNumber: 60,
        expiryDate: 60,
        status: 50,
        refillsRemaining: 60,
        autoRefillStatus: 50,
        pharmacy: 80,
        nextRefillDate: 80,

        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 180, // group actions column
    },
    filterFlyoutWidths: {
        rxNumber: 180,
        status: 300
    },
    valueColors: {},
    actionIcons: {
        toDos: 'checkedContent',
        refillRx: 'rxRefill',
        renewRx: 'rxRefill',
        checkout: 'cart',
        enableAuto: 'enable',
        disableAuto: 'disable',
        cagName: 'info',
        discontinueRx: 'discontinueRx'
    },
    highlight: {
        refillRx: '#e01d20'
    },
    columnIcons: {
        drugName: {
            name: 'info',
            path: 'values.drugNameInfo'
        },
        cagName: {
            name: 'info',
            path: 'values.cagNameInfo'
        }
      
    }
};
